module.exports = __webpack_public_path__ + "img/blog-3.8dfc84e7.jpg";